var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "header checkout-header" },
    [
      _c("div", { staticClass: "main-bar" }, [
        _c(
          "div",
          { staticClass: "container" },
          [
            _c(
              "a",
              { staticClass: "logo", attrs: { href: "/" } },
              [
                _c("f-sprite-icon", {
                  attrs: { "icon-link": _vm.$options.icons.IconLogo.id }
                })
              ],
              1
            ),
            _c("vue-client-only", [
              _vm.adaptive.isDesktop
                ? _c("div", { staticClass: "city" }, [
                    _c(
                      "div",
                      {
                        staticClass: "current",
                        on: {
                          click: function($event) {
                            _vm.$city.isCityHeaderShown = !_vm.$city
                              .isCityHeaderShown
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.CITY.name) +
                            "\n            "
                        ),
                        _c("chevron-animated", {
                          attrs: { reverse: _vm.$city.isCityHeaderShown }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "search" },
                      [
                        _c(
                          "ui-dropdown",
                          {
                            attrs: {
                              left: "",
                              visible: _vm.$city.isCityHeaderShown
                            },
                            on: {
                              "on-close": function($event) {
                                _vm.$city.isCityHeaderShown = false
                              }
                            }
                          },
                          [
                            _c("city-search", {
                              on: { choose: _vm.changeCity }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ]),
            _vm._m(0),
            _c(
              "div",
              { staticClass: "icons" },
              [
                !_vm.isSomeCsmMode ? _c("control-user") : _vm._e(),
                !_vm.isSomeCsmMode
                  ? _c("control-favorites", { staticClass: "icon" })
                  : _vm._e()
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("nav-bar")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "phone" }, [
      _c("a", { attrs: { href: "tel:+78007700101" } }, [
        _vm._v("\n          8 800 770 01 01\n        ")
      ]),
      _c("span", [_vm._v("Мы принимаем звонки c 7:00 до 22:00 (мск)")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }